export default __webpack_public_path__ + "static/media/heroimage-1366.c0ef9115.png";